<template>
  <div class="home">
    <header-bar></header-bar>
    <div class="main-content">
      <!-- Mobile select dropdown -->
      <div class="mobile-select">
        <select v-model="activePanel">
          <option value="left">{{ userTown }} Happenings</option>
          <option value="right">Local News</option>
        </select>
      </div>
      <div class="empty-left"></div>
      <left 
        v-if="!isMobile || activePanel === 'left'"
        class="left-panel" 
        :settings="settings"
        :userTown="userTown">
      </left>
      <right 
        v-if="!isMobile || activePanel === 'right'"
        class="right-panel" 
        :settings="settings">
      </right>
      <div class="right-sidenotes"></div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderBar from './RevisedHeader.vue';
import Left from './LeftHome.vue';
import Right from './RightHome.vue';
import FooterBar from './FooterBar.vue';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '@/firebase';

export default {
name: 'HomePage',
components: {
  HeaderBar,
  Left,
  Right,
  FooterBar,
},
data() {
  return {
    activePanel: 'left',
    isMobile: window.innerWidth < 768,
    userTown: 'Loading',
    settings: {
      selectBoard: true,
      schoolBoard: true,
      otherTownMeetings: true,
      commissionGroup: true,
      upcomingMeetings: true,       // New key
      minutesOnly: true,     // New key
      vtDigger: true,
      sevenDays: true,
      addisonIndependent: true,
      vtPublic: true,
      brandonReporter: true,
      aiSummary: true,
    },
    showSettings: false,
    unsubscribe: null,
  };
},
mounted() {
    window.addEventListener('resize', this.checkMobile);
    this.unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        this.fetchUserSettings(user.uid);
      } else {
        // console.log('No user authenticated');
      }
    });
  },
beforeUnmount() {
  window.removeEventListener('resize', this.checkMobile);
  if (this.unsubscribe) {
      this.unsubscribe();
    }
},
methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },

    async fetchUserSettings(userId) {
      try {
        const userDoc = await getDoc(doc(db, 'users', userId));
        if (!userDoc.exists()) {
          // console.log('No user document found');
          return;
        }

        const userData = userDoc.data();
        const newSettings = { ...this.settings };

        // Map town settings
        if (userData.enabledTownSettings?.length) {
          const townSettings = {
            selectBoard: 'selectBoard',
            schoolBoard: 'schoolBoard',
            otherTownMeetings: 'otherTownMeetings',
            commissionGroup: 'commissionGroup',
            upcomingMeetings: 'upcomingMeetings',
            minutesOnly: 'minutesOnly'
          };

          Object.keys(townSettings).forEach(key => {
            newSettings[townSettings[key]] = userData.enabledTownSettings.includes(key);
          });
        }

        // Map publication settings
        if (userData.enabledPublications?.length) {
          const pubSettings = {
            vtDigger: 'vtDigger',
            sevenDays: 'sevenDays',
            addisonIndependent: 'addisonIndependent',
            vtPublic: 'vtPublic',
            brandonReporter: 'brandonReporter'
          };

          if (userData.address?.city) {
            this.userTown = userData.address.city;
            // console.log('User Town:', this.userTown);
          }

        Object.keys(pubSettings).forEach(key => {
          newSettings[pubSettings[key]] = userData.enabledPublications.includes(key);
        });
      }

        this.settings = newSettings;
      } catch (error) {
        console.error('Error fetching user settings:', error);
      }
    }
  }
};
</script>

<style scoped>
.home {
display: flex;
flex-direction: column;
height: 100vh;
}

.main-content {
position: relative;
flex: 1;
display: flex;
overflow: hidden;
}

.empty-left {
display: flex;
flex: 1;
background-color: #fffff8;
}

.right-sidenotes {
display: flex;
flex: 1;
background-color: #fffff8;
}

.left-panel {
flex: 2;
overflow-y: auto;
min-width: 0;
}

.right-panel {
flex: 2;
overflow-y: auto;
min-width: 0;
}

.mobile-select {
margin-bottom: 24px;
position: relative;
width: max-content;
margin: 0 auto;
}

.mobile-select select {
font-size: 32px;
font-weight: 600;
color: #545051;
padding-top: 24px;
border: none;
border-bottom: 1px dashed #545051;
background-color: #fffff8;
cursor: pointer;
text-underline-offset: 2px;
appearance: none;
-webkit-appearance: none;
-moz-appearance: none;
width: 100%;
text-align: center;
text-align-last: center;
}

.mobile-select select:focus {
outline: none;
border-bottom: 2px dashed #545051;
}

@media (max-width: 767px) {
.mobile-select {
  display: block;
  padding-top:64px;
}
.main-content {
  flex-direction: column;
}
.empty-left,
.right-sidenotes {
  display: none !important;
}
.left-panel,
.right-panel {
  flex: 1;
}
}

@media (min-width: 768px) and (max-width: 1023px) {
.mobile-select {
  display: none;
}
.main-content {
  flex-direction: row;
}
.empty-left,
.right-sidenotes {
  display: none !important;
}
.left-panel,
.right-panel {
  flex: 1;
}
}

@media (min-width: 1024px) {
.mobile-select {
  display: none;
}
.main-content {
  flex-direction: row;
}
.empty-left,
.right-sidenotes {
  display: flex;
}
.left-panel,
.right-panel {
  flex: 2;
}
}
</style>